import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import ArticleIcon from '@mui/icons-material/Article';
import LaunchIcon from '@mui/icons-material/Launch';

function Blog() {
    return (
        <Box sx={{ mt: 5 }}>
            <Typography 
                className="subTitle" 
                variant="h4" 
                gutterBottom 
                component="div" 
                sx={{ fontWeight: 'medium', m: 1 }}
            >
                Blog
            </Typography>
            
            <Card 
                sx={{ 
                    maxWidth: '100%', 
                    mx: 'auto', 
                    mt: 2,
                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                    }
                }}
            >
                <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <ArticleIcon sx={{ fontSize: 32, color: '#1976d2', mr: 1 }} />
                        <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold' }}>
                            Kevin's Tech Blog
                        </Typography>
                    </Box>
                    
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
                        Dive into my thoughts on technology, web development, server management, and all things tech. 
                        I share tutorials, insights, and experiences from my journey as a Computer Science student and tech enthusiast.
                    </Typography>
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3, fontStyle: 'italic' }}>
                        From homelab setups to web development tips, network engineering concepts to programming tutorials - 
                        explore the digital world through my perspective.
                    </Typography>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Link 
                            href="https://blog.kevinazemi.com/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            underline="none"
                        >
                            <Button 
                                variant="contained" 
                                size="large"
                                endIcon={<LaunchIcon />}
                                sx={{
                                    bgcolor: '#1976d2',
                                    '&:hover': {
                                        bgcolor: '#115293',
                                        transform: 'scale(1.02)'
                                    },
                                    borderRadius: '25px',
                                    px: 3,
                                    py: 1.5,
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                Visit My Blog
                            </Button>
                        </Link>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Blog;